<template>
  <jc-dialog ref="dialog" :show.sync="show"
             btn-confirm-text='<i class="far fa-trash-alt"></i> Xóa'
             title="Xác nhận xóa"
             type="red"
             @onConfirm="onDelete()"
  >
    <table class="table table-hover">
      <tr>
        <th>#</th>
        <td>{{ model.index }}</td>
      </tr>
      <tr>
        <th>Mã tài nguyên</th>
        <td>{{ model.code }}</td>
      </tr>
      <tr>
        <th>Mô tả</th>
        <td>{{ model.description }}</td>
      </tr>
    </table>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "Delete",
  mixins: [
    dialogMixins,
  ],
  data() {
    return {
      model: {},
    }
  },
  methods: {
    open(item) {
      if (item) {
        this.show = true;
        this.model = item;
      } else {
        this.$warning('Chưa chọn bản ghi nào')
      }
    },
    onDelete() {
      this.$showLoader();
      const vue = this;
      let data = vue.model;
      vue.$http
         .delete("/cms/api/v1.0/admin/roles/" + data.id)
         .then(successRes => {
           this.close();
           this.$success();
           this.$stopLoader();

           this.$emit("success", successRes);
         }, errorRes => {
           this.$stopLoader();
           this.errorNotify(errorRes);
           this.$emit("error", errorRes);
         });
    }
  }
}
</script>

<style scoped>

</style>